import React, { useEffect, useState } from 'react';
import Book from '../../Admin/Book/Book';
import ServiceCard from '../ServiceCard/ServiceCard';
import './ServiceInfo.css';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const ServiceInfo = () => {

    const [services, setServices] = useState([]);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const handleToggle = () => setOpen(!open);

    useEffect(() => {
        handleToggle();
        fetch('https://floating-brushlands-99076.herokuapp.com/services')
        .then(res => res.json())
        .then(data => {
            setServices(data)
            handleClose()
        })
    },[])
    return (
        <div className="container mt-5 mb-3 pt-5">
            <div className="d-flex justify-content-center align-items-center">
                <h2 className="title-style">Service Information</h2>
            </div>
            <div>
                <div className="row d-flex justify-content-center mt-5 mb-5 pb-5">
                    {
                        services.map(service => <ServiceCard service={service} key={service._id}></ServiceCard>)
                    }
                </div>
            </div>

            {/* Backdrop */}
            <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
                <CircularProgress color="inherit" />
                <h5 className="ml-2">Please Wait...</h5>
            </Backdrop>
        </div>
    );
};

export default ServiceInfo;